export default {
  name: 'wechatAdd',
  data() {
    return {
      pageSize:8,
      pageIndex:1,
      total:0,
      wechatInputRulePop:false,
      rulepop:false,
      agreerule:false,
      loading:false,
      formValidate:{
        username:'',
        password:''
      },
      ruleValidate: {
        username: [
            { required: true, message: '微博账号不能为空', trigger: 'blur' }
        ],
        password: [
            { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      },
      list:[]
    }
  },
  watch:{
  },
  computed:{
    type(){
      return this.$route.query.type;
    },
    pageCount(){
      return Math.ceil(this.total/this.pageSize);
    }
  },
  created() {
   this.$store.commit('tabname','wechat');
   this.getList();
    // console.log(this.$store.state.menuActiveName);
  },
  mounted() {
	},
  methods: {
    changePage(page){
      this.pageIndex=page;
      this.getList();
    },
    showRule(){
      this.rulepop=true;
      this.agreerule=false;
    },
    ruleNext(){
      this.rulepop=false;
      this.checkWechatAuth();
    },
    checkWechatAuth(){
      this.$http.get('front/channel/audit/get').then(({data})=>{
        if(data.status == 1 && data.accountstatus == 'Y'){
          this.getWechatCodePage();
        }else if(data.status == 1 && data.remainingtime){
          //秒转化为小时分钟
          let h = parseInt(data.remainingtime/3600);
          let m = parseInt((data.remainingtime - h*3600)/60);
          let s = data.remainingtime % 60;
          let tipstr='';
          if(h > 0){
            tipstr = h + "小时" + m + "分" + s + "秒";
          }else if(m > 0){
            tipstr = m + "分" + s + "秒";
          }else if(s > 0){
            tipstr = s + "秒";
          }
          this.$Notice.warning({title:tipstr + "后，可以添加微信渠道",desc:false})
        }else{
          this.$Notice.error({title:data.message,desc:false})
        }
      },(error)=>{
        this.$Notice.error({title:error.data.message,desc:false})
      })
    },
    getWechatCodePage(){
      let url=this.$conf.host+this.$conf.serverRoot+"zmt/publish/wechat/auth/code?referer="+encodeURIComponent(this.$conf.host+"#/wechatadd/success")+"&zmttoken="+this.$store.state.token+"&ptype="+this.type;
      let iTop = (window.screen.availHeight-630)/2;
      let iLeft = (window.screen.availWidth-1210)/2;
      window.open(url,'_blank','width=1200,height=600,top='+iTop+',left='+iLeft+',menubar=no,toolbar=no,status=no,scrollbars=yes') ;
    },
    ruleCancel(){
      this.rulepop=false;
    },
    getList(){
      this.loading=true;
        this.$http.get('front/channel',{
          params:{
            pagesize:this.pageSize,
            pageindex:this.pageIndex-1,
            type:'WeChat',
            ptype:this.type,
            audit:false
          }
        }).then((res)=>{
          this.loading=false;
          // console.log(res);
          if(res.data.status == 1){
            this.total=res.data.total;
            this.list=res.data.channels;
          }else{
            this.total=0;
            this.$Notice.error({title:res.data.message,desc:false});
          }
        },(error)=>{
          this.loading=false;
          this.total=0;
          this.$Notice.error({title:error.data.message,desc:false});
        })
    },
    changeWebPublishType(type,id){
       if(type == "Y"){
        // 设置为自动
        this.confirmPop('确认将发布设置改为自动发布，修改后内容同步后将自动发布？',()=>{this.operateWechatPublishType(type,id)},()=>{this.cancelSetPublishType('N',id)});
      }else{
        //设置为手动
        this.confirmPop('确认将发布设置改为手动发布，修改后内容状态为草稿，编辑后发布？',()=>{this.operateWechatPublishType(type,id)},()=>{this.cancelSetPublishType('Y',id)});
      }
    },
    operateWechatPublishType(type,id){
      this.$http.put('front/channel/'+id,{robopostxmt:type}).then(res => {
        if (res.data.status == 1) {
          this.$Notice.success({title:res.data.message,desc:false});
          //获得列表
          this.getList();
        } else {
          this.$Notice.error({title:res.data.message,desc:false});
        }
      }, err => {
        this.$Notice.error({title:err.data.message,desc:false});
      })
    },
    cancelSetPublishType(option,id){
       this.list.forEach((obj,key)=>{
        if(obj.id == id){
          obj.robopostxmt=option;
        }
      });
    },
    confirmPop(content,sucCallback,failCallback){
       this.$Modal.confirm({
        title: '确认提示',
        content: content,
        onOk: () => {
          sucCallback && sucCallback();
        },
        onCancel: ()=>{
          failCallback && failCallback();
        }
      });
    },
    unbind(id){
      this.$http.delete('front/channel/'+id).then((response)=>{
        if(response.data.status == 1){
           this.$Notice.success({title:response.data.message,desc:false});
           this.getList();
        }else{
          this.$Notice.error({title:response.data.message,desc:false});
        }
      },(error)=>{
         this.$Notice.error({title:error.data.message,desc:false});
      })
    },
    unbindWechat(id){
      this.confirmPop('你确定要解绑该微信渠道吗？',()=>{this.unbind(id)});
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/channel/wechatadd/index.js